import {
  createMemoryHistory,
  createRouter,
  createWebHistory,
} from 'vue-router';
import type { Pinia } from 'pinia';
import { isLogin, clearToken } from '@/utils/auth';
import useAppStore from '../stores/modules/app';
import useUserStore from '../stores/modules/user';
import { routes } from './routes';

/** 共享判定：仅判断，不产生副作用，两端共用 */
export function needAuth(to: { matched: { meta: Record<string, any> }[] }) {
  return to.matched.some(record => record.meta.requiresAuth);
}

export function createAppRouter({ pinia }: { pinia: Pinia }) {
  const router = createRouter({
    history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      else if (to.hash) {
        return {
          el: to.hash,
          top: 70,
          behavior: 'smooth',
        };
      }
      else {
        return {
          top: 0,
        };
      }
    },
  });

  if (!import.meta.env.SSR) {
    router.beforeEach(async () => {
      const appStore = useAppStore(pinia);
      const userStore = useUserStore(pinia);

      await appStore.ensureSiteLoaded();

      if (isLogin()) {
        if (!userStore.user.id) {
          const { isSuccess } = await userStore.fetchInfo();

          if (!isSuccess) {
            // 登录有效但是取不出来用户信息，说明登录信息有问题，属于未登录状态
            // 清理登录信息
            clearToken();
          }
        }
      }

      return true;
    });

    import('./client-progress').then(m => m.installProgress(router));
  }

  return router;
}
